import {
	BlastOrgPermsDto,
	SiteDto,
	SitePermsDto,
} from "../../../types/blastDtos";
import { OrgProfileDto } from "../../../types/dto";
import { getBlast, isMockMode, simulateDelay } from "../../api";

interface SiteAndPermissions {
	site: SiteDto;
	permissions: SitePermsDto;
}

interface BlastOrgAndPermissions {
	org: OrgProfileDto;
	permissions: BlastOrgPermsDto;
	sites: Array<SiteAndPermissions>;
}

interface GetBlastUserMetadataResponse {
	orgsAndPermissions: Array<BlastOrgAndPermissions>;
}

const mapPermsToOrgs = (data: GetBlastUserMetadataResponse) => {
	const orgs = data.orgsAndPermissions.map(({ org, permissions, sites }) => {
		return {
			...org,
			permissions,
			sites: sites.map(({ site, permissions }) => ({
				...site,
				permissions,
			})),
		};
	});
	return { orgs };
};

export const getBlastUserMetadata = () => {
	if (isMockMode()) {
		const testData = {
			orgsAndPermissions: [
				{
					org: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						name: "Test Name",
					},
					permissions: {
						isOrgAdmin: true,
					},
					sites: [
						{
							site: {
								id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
								name: "Test Name",
								subscriptionId:
									"3fa85f64-5717-4562-b3fc-2c963f66afa6",
								subscriptionSubscriberOrgId:
									"3fa85f64-5717-4562-b3fc-2c963f66afa6",
							},
							permissions: {
								isSubManager: true,
								isSiteAdmin: true,
								isSiteUser: true,
							},
						},
					],
				},
			],
		};

		return simulateDelay(50, () => testData).then(mapPermsToOrgs);
	}

	return getBlast(`user/getmetadata?includeOrgAvatars=true`).then(
		mapPermsToOrgs
	);
};
